export default __webpack_public_path__ + "static/media/Rubik-Bold.383b8c94.ttf";